// extracted by mini-css-extract-plugin
export default {"tableFooterContainer":"TableFooter_tableFooterContainer__Da1sg","showMore":"TableFooter_showMore__cbs+7","showAll":"TableFooter_showAll__-4H48"};